import Vue from "vue";
const moment = require("moment");
import axios from "axios";
import store from "../store";
import track from "./track";
import auth from "./auth";
import PortalVue from "portal-vue";
import VueMeta from "vue-meta";
import VueClipboard from "vue-clipboard2";
import VueCarousel from "vue-carousel";
import { version } from "../../package.json";
import InfiniteScroll from "vue-infinite-scroll";

import {
	cookie,
	getParameterByName,
	focusAndOpenKeyboard,
	validatePhoneNumber,
} from "./index";
const analytics = require("./analytics").default;
const notifications = require("./notifications").default;
if (
	process.env.NODE_ENV === "production" ||
	process.env.NODE_ENV === "staging"
) {
	const { registerServiceWorker } = require("../assets/scripts/pwa");
	registerServiceWorker()
		.then((registration) => (Vue.prototype.$swRegistration = registration))
		.catch((error) => (Vue.prototype.$swRegistration = null));
}

// Services
Vue.use(VueClipboard);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VueCarousel);
Vue.use(InfiniteScroll);
Vue.prototype.$tracking = analytics;
Vue.prototype.$notifications = notifications;
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$version = version;
Vue.prototype.$track = track;
Vue.prototype.$auth = auth;
Vue.prototype.$cookie = cookie;
Vue.prototype.$moment = moment;
const utils = {
	cookie,
	getParameterByName,
	focusAndOpenKeyboard,
	validatePhoneNumber,
};
window.utils = utils;
Vue.prototype.$utils = utils;
String.prototype.capitalize = function () {
	return this.replace(/(?:^|\s)\S/g, function (a) {
		return a.toUpperCase();
	});
};
String.prototype.isMatch = function (regex) {
	return this.match(regex) !== null;
};

// Variables
let isOPR = window.navigator.userAgent.indexOf("OPR") > -1;
let isSDV2 = window.location.search.toLowerCase().indexOf("sdv2") > -1;
let closedLiteBanner = cookie.get("closed_lite_banner");
window.isAndroid = navigator.userAgent.match(/Android/i) ? true : false;
Vue.prototype.isAndroid = navigator.userAgent.match(/Android/i) ? true : false;
if ((isOPR || isSDV2) && !closedLiteBanner) {
	window.isAndroid = true;
	Vue.prototype.isAndroid = true;
}
window.canShowAndroidBanner =
	(localStorage.hasOwnProperty("showAndroidBanner")
		? JSON.parse(localStorage.showAndroidBanner)
		: false) && window.isAndroid;
Vue.prototype.canShowAndroidBanner =
	(localStorage.hasOwnProperty("showAndroidBanner")
		? JSON.parse(localStorage.showAndroidBanner)
		: false) && window.isAndroid;

window.isPWA = getParameterByName("utm_source") == "pwa";
window.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
Vue.prototype.isSafari = /^((?!chrome|android).)*safari/i.test(
	navigator.userAgent
);

// Configure axios
axios.defaults.headers.post["Content-Type"] =
	"application/x-www-form-urlencoded";

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error.response) {
			try {
				decibelInsight("sendHTTPError", error.response.status);
			} catch (e) {}
		}
		// Do something with response error
		return Promise.reject(error);
	}
);
